module.exports = __webpack_public_path__ + "img/darkgrownflownotice.837a17de.png";